import { Group, Stack, Text, Title } from "@mantine/core";
import { motion } from "framer-motion";

import { OrnamentalDivider, SideFlourish } from "../decorative-lines/decorative-lines";
import styles from "./section-title.module.css";

export const SectionTitle = ({ title, subTitle, isH1 }: { title: string; subTitle: string; isH1?: boolean }) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.6, ease: "easeOut" }}>
            <Stack gap="md" align="center">
                <Group align="center" gap="md">
                    <SideFlourish color="white" w={60} className={styles.sideFlourish} />
                    <Text className={styles.supTitle}>{subTitle}</Text>
                    <SideFlourish color="white" w={60} flipped className={styles.sideFlourish} />
                </Group>
                <Title order={isH1 ? 1 : 2} className={styles.sectionTitle}>
                    {title}
                </Title>
                <OrnamentalDivider color="white" maw={300} />
            </Stack>
        </motion.div>
    );
};
